
import Base from "../base/Base.vue";
import { Options } from "vue-class-component";
import AllProfile from "./index";
import { watchEffect } from "vue";
@Options({
  components: AllProfile
})
export default class ProfileUser extends Base {
  public selected: any = {};
  challengeType = 1;

  created() {
    watchEffect(() => {
      this.selected = this.dataProfile.find(
        (s: any) => s.id === this.challengeType
      ) as any;
    })
  }

  dataProfile = [
    {
      id: 1,
      name: "Profile",
      description: "",
      icon: "account_circle",
      settings: [{ id: 0, name: "InfoProfile" }]
    },
    {
      id: 2,
      name: "My Collection",
      description: "",
      icon: "all_inbox",
      settings: [{ id: 0, name: "MyChallenge" }]
    },
    {
      id: 3,
      name: "History",
      description: "Coming soon",
      icon: "restore",
      settings: [],
      comingsoon: true
    }
  ];

  onRowSelect(event: any) {
    if (event.data.settings > 0) {
      this.selected = event.data;
    }
    this.challengeType = event.data.id;
  }
}
